/**
 * Modal interaction with the API
 *
 * @component
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';
// Import Moal
import modaal from 'modaal/source/js/modaal.js';
import UploadImages  from './_filepond.js';

class ApiModals {
    getClassName() {return 'ApiModals';}
    constructor(){
        let self = this;
        self.logger = ClassLogger(self, true);

        self.errorIntro = 'Fehler: ';
        self.defaultError = 'Es trat ein Fehler auf! Bitte laden Sie die Seite neu und versuchen Sie es noch einmal.';

        // applicants
        self.modalDialogue('[data-application-button]', self.applicationForm, null, 'Jobs', 'application');
        self.modalDialogue('[data-wunschtermin-button]', self.wunschtermin, null, 'Company', 'appointment');

        // companies
        self.modalDialogue('[data-invitetocompany-button]', self.invitetocompany, null, 'Company', 'invite');

        // jobs
        self.modalDialogue('[data-addjob-button]', self.addjob, null, 'Job', 'create');
        self.modalDialogue('[data-publishjob-button]', self.publishjob, null, 'Job', 'publish');
        self.modalDialogue('[data-unpublishjob-button]', self.unpublishjob, null, 'Job', 'unpublish');
        self.modalDialogue('[data-deletejob-button]', self.deletejob, null, 'Job', 'delete');

        // contacts
        self.modalDialogue('[data-addprofile-button]', self.addprofile, null, 'Company', 'addprofile');
        self.modalDialogue('[data-updatecontact-button]', self.updatecontact, self.updatecontactPrepare, 'Company', 'updatecontact');


        // media
        self.modalDialogue('[data-deletemedia-button]', self.deletemedia, null);

        $('[href="#loginrequired"]').modaal({
            background: '#fff',
            width: 500,
            hide_close: false,
            is_locked: false,
            after_open: function(modal_wrapper){
                // re-init tabs to make them work (this is required, since modaal duplicates the DOM element)
                $(modal_wrapper).find('[data-tabs]').foundation('_destroy');
                new Foundation.Tabs($(modal_wrapper).find('[data-tabs]'));
            }
        });

        self.mediauploadService = new UploadImages();

    }

    //------------------------------------ Business Logic


    applicationForm(self, modal_wrapper, params) {
        let uri = '/jobs/' + params.jobid + '/applications';
        // Request Data
        Api.request('POST', uri)
        .then(function(response) {
            self.modalSuccess(modal_wrapper, 'Ihre Bewerbung wurde erfolgreich versendet.');

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });

    }

    wunschtermin(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.jobid === undefined || params.jobid  == '') params.jobid  = null;
        if (params.companyid === undefined || params.companyid == '') {
            alert('Fehler! (Company ID not set');
            return;
        }

        let uri = '/companies/' + params.companyid + '/appointments';

        let starttime = $instance.find('[name="von"]').val();
        let endtime = $instance.find('[name="bis"]').val();
        let appointmentdate = $instance.find('[name="appointmentdate"]').val();
        let contacttype = $instance.find('[name="contacttype"]:checked').val();

        // Construct our time for API Example date format for API call "2020-11-14T17:00:00"
        let apiStartTime = appointmentdate + 'T' + starttime + ':00';
        let apiEndTime = appointmentdate + 'T' + endtime + ':00';

        let data = {
            'start': apiStartTime,
            'end': apiEndTime,
            'jobid': params.jobid,
            'message' : '',
            'contacttype': contacttype
        };

        // Request Data
        Api.request('POST', uri, data)
        .then(function(response) {
            self.modalSuccess(modal_wrapper, 'Ihre Terminanfrage wurde erfolgreich an das Unternehmen weitergeleitet.');

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    addjob(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.companyid === undefined || params.companyid == '') {
            alert('Fehler! (Company ID not set');
            return;
        }

        let uri = '/jobs';

        let data = {
            'companyid': params.companyid,
            'title' : $instance.find('[name="title"]').val(),
            'content' : '',
            'introtext': '',
            'location' : ''
        };

        // Request Data
        Api.request('POST', '/jobs', data)
        .then(function(response) {
            self.modalSuccess(modal_wrapper, 'Sie werden weitergeleitet…');
            self.logger.log(response);
            window.document.location = response.data.profile.uri + '/bearbeiten';

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    publishjob(self, modal_wrapper, params) {

        let $instance = $(modal_wrapper);

        if (params.jobid === undefined || params.jobid == '') {
            alert('Fehler! (Job ID not set');
            self.modalError(modal_wrapper);
            return;
        }

        params.expireson = $instance.find('#field-expireson').val();
        params.class = $instance.find('#field-class').val();

        if (params.class === null || params.class === undefined || params.class == '') {
            self.modalError(modal_wrapper, 'Bitte wählen Sie einen Job-Typ aus.');
            return;
        }

        let data = {
            'published': true,
            'class': params.class
        };

        if (window.fbq) {
            switch (params.class) {
                case 'default':
                    window.fbq('track', 'Purchase', {value: 250.00, currency: 'EUR'});
                    break;
                case 'topjob':
                    window.fbq('track', 'Purchase', {value: 600.00, currency: 'EUR'});
                    break;
            }
        }
        // Request Data
        Api.request('PUT', '/jobs/'+params.jobid, data)
        .then(function(response) {
            self.modalSuccess(
                modal_wrapper,
                'Ihr Job-Inserat wurde zur Überprüfung eingereicht. Die Überprüfung erfolgt in der Regel werktags innerhalb von 48 Stunden.',
                function(){
                    window.location.reload();
                }
            );

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    unpublishjob(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.jobid === undefined || params.jobid == '') {
            self.modalError('Job-ID wurde nicht übertragen');
            return;
        }

        let data = {
            'published': false
        };

        // Request Data
        Api.request('PUT', '/jobs/'+params.jobid, data)
        .then(function(response) {
            self.modalSuccess(
                modal_wrapper,
                'Die Veröffentlichung wurde erfolgreich zurückgezogen.',
                function(){
                    window.location.reload();
                }
            );

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    deletejob(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.jobid === undefined || params.jobid == '') {
            self.modalError('Job-ID wurde nicht übertragen');
            return;
        }

        // Request Data
        Api.request('DELETE', '/jobs/'+params.jobid, {})
        .then(function(response) {
            self.modalSuccess(
                modal_wrapper,
                'Der Job wurde erfolgreich gelöscht.',
                function(){
                    window.location.reload();
                }
            );

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    deletemedia(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);
        self.logger.log('deleting media', params);

        if (params.targetid === undefined || params.targetid == '') {
            alert('Fehler! (targetid not set');
            return;
        }

        if (params.mediatype === undefined || params.mediatype == '') {
            alert('Fehler! (mediatype not set');
            return;
        }

        // Request Data
        Api.request('DELETE', '/companies/'+params.targetid+'/media/'+params.mediatype, {})
        .then(function(response) {
            self.modalSuccess(modal_wrapper, 'Die Grafik wurde erfolgreich gelöscht.');
            $('#'+params.mediatype).attr('src', $('#'+params.mediatype).data('fallback'));
            self.logger.log(response);

        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }

    addprofile(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.companyid === undefined || params.companyid == '' || params.companylink === undefined) {
            alert('Fehler! (Company ID/Link not set');
            self.modalError(modal_wrapper);
            return;
        }

        params.salutation = $instance.find('#field-addprofile-salutation').val();
        params.firstname = $instance.find('#field-addprofile-firstname').val();
        params.lastname = $instance.find('#field-addprofile-lastname').val();
        params.email = $instance.find('#field-addprofile-email').val();
        params.phone = $instance.find('#field-addprofile-phone').val();

        params.type = $instance.find('#field-addprofile-type').val();
        params.sendemail = $instance.find('#field-addprofile-sendemail').val();

        if (params.sendemail === null || params.sendemail === undefined || params.sendemail == '') {
            params.sendemail = true;
        } else if (params.sendemail == 'true') {
            params.sendemail = true;
        } else {
            params.sendemail = false;
        }


        if (params.salutation === null || params.salutation === undefined || params.salutation == '') {
            self.modalError(modal_wrapper, 'Bitte wählen Sie eine Anrede aus.');
            return;
        }

        if (params.lastname === null || params.lastname === undefined || params.lastname == '') {
            self.modalError(modal_wrapper, 'Bitte geben Sie den Namen ein.');
            return;
        }

        if (params.email === null || params.email === undefined || params.email == '') {
            self.modalError(modal_wrapper, 'Bitte geben Sie die E-Mail-Adresse ein.');
            return;
        }

        let data = {
            'email': params.email.toLowerCase(),
            'salutation': params.salutation,
            'firstname': params.firstname,
            'lastname': params.lastname,
            'phone': params.phone
        };

        if (params.type == 'profile') {
            data._sendemail = params.sendemail;

            self.logger.log('Adding contact as Profile (Invite)', data);

            Api.request('POST', '/companies/'+params.companyid+'/invite', data)
            .then(function(response) {
                if (typeof response.data === 'undefined') {
                    self.modalError(modal_wrapper, response);
                    return;
                }

                if (params.sendemail === false) {
                    if (typeof response.data.emailtoken !== 'undefined') {
                        let link = params.companylink + '/einladung/' + response.data.emailtoken + ',' + response.data.passwordtoken;
                        self.modalSuccess(modal_wrapper, '<textarea style="height:6.25rem;">'+link+'</textarea>');
                    } else {
                        self.modalSuccess(modal_wrapper, 'Der Empfänger verfügt bereits über einen Account und wurde dem Unternehmen hinzugefügt.');
                    }

                } else {
                    let tpl = $('#profileTpl').html();
                    tpl = tpl.replace(/REPLACE_PROFILE_ID/g, response.data.id);
                    tpl = tpl.replace(/REPLACE_COMPANY_ID/g, params.companyid);
                    let $tpl = $(tpl);
                    $('[data-placeholder]', $tpl).each(function(i, item){
                        let placeholderKey = $(item).data('placeholder');
                        if (typeof response.data[placeholderKey] !== 'undefined') {
                            $(item).text(response.data[placeholderKey]);
                        } else {
                            $(item).text('');
                        }
                    });

                    $tpl.find('[data-profile]').data('profile', response.data);
                    $('#contactList li[data-accountstatus!="0"]').last().after($tpl);

                    self.modalSuccess(modal_wrapper, 'Die Einladung wurde erfolgreich versendet!');
                }

            }).catch(function(exception){
                self.modalError(modal_wrapper, exception);
            });

        } else {

            self.logger.log('Adding contact as Contact', data);

            // Request Data
            Api.request('POST', '/companies/'+params.companyid+'/members', data)
            .then(function(response) {
                self.logger.log(response);
                if (typeof response.data === 'undefined') {
                    self.modalError(modal_wrapper, response);
                    return;
                }

                self.modalSuccess(modal_wrapper, 'Die Kontaktdaten wurden erfolgreich gespeichert.');

                let tpl = $('#contactTpl').html();
                tpl = tpl.replace(/REPLACE_PROFILE_ID/g, response.data.id);
                tpl = tpl.replace(/REPLACE_COMPANY_ID/g, params.companyid);
                let $tpl = $(tpl);
                $('[data-placeholder]', $tpl).each(function(i, item){
                    let placeholderKey = $(item).data('placeholder');
                    if (typeof response.data[placeholderKey] !== 'undefined') {
                        $(item).text(response.data[placeholderKey]);
                    } else {
                        $(item).text('');
                    }
                });

                $tpl.find('[data-profile]').data('profile', response.data);
                $('#contactList').append($tpl);

            }).catch(function(exception){
                self.modalError(modal_wrapper, exception);
            }).finally(function(){
                $(modal_wrapper).find('input').val('');
            });
        }
    }


    updatecontactPrepare(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        $instance.find('[data-deletecontact]').off().on('click', function(e){
            if (params.contactid === undefined || params.contactid == '') {
                alert('Fehler! (Contact ID not set');
                self.modalError(modal_wrapper);
                return;
            }

            if (params.companyid === undefined || params.companyid == '') {
                alert('Fehler! (Company ID not set');
                self.modalError(modal_wrapper);
                return;
            }

            $instance.find('.c-preloader-overlay').fadeIn();

            Api.request('DELETE', '/companies/'+params.companyid+'/members/'+params.contactid)
            .then(function(response) {
                self.logger.log(response);
                if (typeof response.data === 'undefined') {
                    self.modalError(modal_wrapper, response);
                    return;
                }

                $('#contactList [data-contactid="'+params.contactid+'"]').slideUp(400);

                self.modalSuccess(modal_wrapper, 'Der Ansprechpartner wurde erfolgreich gelöscht.', function(){
                    setTimeout(function(){
                        $('#contactList [data-contactid="'+params.contactid+'"]').remove();
                    }, 100);
                });

            }).catch(function(exception){
                self.modalError(modal_wrapper, exception);
            });
        });

        // init new Mediaupload
        let $mediaElement = $(modal_wrapper).find('[data-mediaupload]');
        let mediauploadOptions = $mediaElement.data('mediaupload');
        mediauploadOptions.targetid = params.contactid;
        $mediaElement.attr('data-mediaupload', JSON.stringify(mediauploadOptions));
        $mediaElement.data('mediaupload', mediauploadOptions);
        self.logger.log($mediaElement, mediauploadOptions);
        self.mediauploadService.init($mediaElement);
    }


    updatecontact(self, modal_wrapper, params) {
        let $instance = $(modal_wrapper);

        if (params.contactid === undefined || params.contactid == '') {
            alert('Fehler! (Contact ID not set');
            self.modalError(modal_wrapper);
            return;
        }

        if (params.companyid === undefined || params.companyid == '') {
            alert('Fehler! (Company ID not set');
            self.modalError(modal_wrapper);
            return;
        }

        params.salutation = $instance.find('#field-updatecontact-salutation').val();
        params.firstname = $instance.find('#field-updatecontact-firstname').val();
        params.lastname = $instance.find('#field-updatecontact-lastname').val();
        params.email = $instance.find('#field-updatecontact-email').val();
        params.phone = $instance.find('#field-updatecontact-phone').val();

        if (params.salutation === null || params.salutation === undefined || params.salutation == '') {
            self.modalError(modal_wrapper, 'Bitte wählen Sie eine Anrede aus.');
            return;
        }

        if (params.lastname === null || params.lastname === undefined || params.lastname == '') {
            self.modalError(modal_wrapper, 'Bitte geben Sie den Namen ein.');
            return;
        }

        if (params.email === null || params.email === undefined || params.email == '') {
            self.modalError(modal_wrapper, 'Bitte geben Sie die E-Mail-Adresse ein.');
            return;
        }

        let data = {
            'email': params.email.toLowerCase(),
            'salutation': params.salutation,
            'firstname': params.firstname,
            'lastname': params.lastname,
            'phone': params.phone
        };

        self.logger.log('Updating contact '+params.contactid+'…', data);

        // Request Data
        Api.request('PUT', '/companies/'+params.companyid+'/members/'+params.contactid, data)
        .then(function(response) {
            self.logger.log(response);
            if (typeof response.data === 'undefined') {
                self.modalError(modal_wrapper, response);
                return;
            }

            self.modalSuccess(modal_wrapper, 'Der Ansprechpartner wurde erfolgreich aktualisiert.');

            $('#contactList [data-contactid="'+params.contactid+'"] [data-placeholder]').each(function(i, item){
                let placeholderKey = $(item).data('placeholder');
                if (typeof response.data[placeholderKey] !== 'undefined') {
                    $(item).text(response.data[placeholderKey]);
                } else {
                    $(item).text('');
                }
            });
            $('#contactList [data-contactid="'+params.contactid+'"] [data-updatecontact-button]').data('profile', response.data);


        }).catch(function(exception){
            self.modalError(modal_wrapper, exception);
        });
    }


    //------------------------------------ Modal Logic

    modalError(modal_wrapper, exception) {
        let self = this;
        let error_message = self.defaultError;
        if (typeof exception === 'object'
            && typeof exception.responseJSON === 'object'
            && typeof exception.responseJSON.error !== 'undefined'
            && typeof exception.responseJSON.message === 'string'
        ) {
            error_message = self.errorIntro + exception.responseJSON.message;

        } else if (typeof exception === 'object'
            && typeof exception.error !== 'undefined'
            && typeof exception.message === 'string'
        ) {
            error_message = self.errorIntro + exception.message;

        } else if (typeof exception === 'string') {
            error_message = exception;
        }

        self.logger.log('Error', exception);

        $(modal_wrapper).find('.c-error, .c-modal__close').show();
        $(modal_wrapper).find('.c-modal__content, .c-preloader-overlay').hide();
        // write error message
        $(modal_wrapper).find('.c-error__text').text(error_message);
    }

    modalCancel(modal_wrapper) {
        $(modal_wrapper).find('.c-preloader-overlay').fadeOut();
    }

    modalSuccess(modal_wrapper, message, callback) {
        if (message === undefined || message === '') message = false;
        // User Feedback
        $(modal_wrapper).find('.c-success, .c-modal__close').show();
        $(modal_wrapper).find('.c-modal__content, .c-preloader-overlay').hide();
        // write success message
        if (message) $(modal_wrapper).find('.c-success__text').html(message);
        if (typeof callback === 'function') {
            $(modal_wrapper).find('[data-modal-close]').one('click', callback);
        }
    }

    modalDialogue(selector, sendCallback, afterOpenCallback, eventCategory, eventAction) {
        let self = this;
        let jobId = '';

        let params = {};
        if (typeof afterOpenCallback !== 'function') afterOpenCallback = function(){};

        // Modaal Configuration
        $('body').on('click', selector, function(e){
            let $instance = $(this).first();
            e.preventDefault();
            $instance.modaal({
                start_open: true,
                background: '#fff',
                width: 500,
                hide_close: true,
                is_locked: true,
                after_callback_delay: 0,
                background_scroll: false,

                before_open: function(event) {
                    // get all data attributes from button and store them in params
                    params = $instance.data();
                },

                after_open: function(modal_wrapper){

                    $('html').addClass('modaal-noscroll');

                    $('[data-placeholder]', modal_wrapper).each(function(i, item){
                        let placeholderKey = $(item).data('placeholder');
                        if (typeof params[placeholderKey] !== 'undefined') {
                            $(item).text(params[placeholderKey]);
                        } else {
                            $(item).text('');
                        }
                    });

                    $('[data-placeholdervalue]', modal_wrapper).each(function(i, item){
                        let placeholderKey = $(item).data('placeholdervalue');
                        // convert dot notiation string to object reference
                        // https://stackoverflow.com/a/6394168
                        let value = placeholderKey.split('.').reduce((o,i)=>o[i], params);
                        if (value !== 'undefined') {
                            $(item).val(value);
                        } else {
                            $(item).val('');
                        }
                    });

                    self.logger.log('Opening modal', params);

                    window.e(eventCategory, 'open-'+eventAction);

                   // Add cancel button listener
                    $(modal_wrapper).on('click', '[data-modal-cancel], [data-modal-close]', function(){
                        $instance.modaal('close');
                    });

                    if ($(modal_wrapper).find('[data-modal-form-send]').length) {
                        // On button action
                        $(modal_wrapper).find('[data-modal-form-send]').off().on('click',function(){

                            let missing = false;
                            $(modal_wrapper).find('input[required], select[required]').each(function(i, input){
                                if ($(input).val() == '') {
                                    $(input).parent().addClass('u-error--label-wrapper-simple');
                                    missing = true;
                                    return;
                                } else {
                                    $(input).parent().removeClass('u-error--label-wrapper-simple');
                                }
                            });
                            // stop click handler if required input is missing
                            if (missing === true) return false;

                            // Trigger preloader
                            $(modal_wrapper).find('.c-preloader-overlay').fadeIn();
                            self.logger.log('triggering callback ' + sendCallback.name, params);
                            window.e(eventCategory, 'send-'+eventAction);
                            sendCallback(self, modal_wrapper, params);
                        }); // end of on click
                    } else {
                        // if no submit button exists, continue with callback right away
                        $(modal_wrapper).find('.c-preloader-overlay').fadeIn();
                        self.logger.log('triggering callback ' + sendCallback.name, params);
                        sendCallback(self, modal_wrapper, params);
                    }

                    afterOpenCallback(self, modal_wrapper, params);
                },

                before_close: function() {
                    $('html').removeClass('modaal-noscroll');
                },

                after_close: function(){
                    // reset all visual elements in case user evokes again
                    $('.c-modal__feedback').find('.c-success, .c-modal__close, .c-error, .c-preloader-overlay').hide();
                    $('.c-modal__content').show();
                }
            });
            return false;
        });

    }

}

export default new ApiModals();
